/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HospitalMessage
 */
export interface HospitalMessage {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    message: string;
    /**
     * 
     */
    author_full_name: string;
    /**
     * 
     */
    sent_from_exacare?: boolean;
    /**
     * 
     */
    date_sent_iso: string;
    /**
     * 
     */
    is_delivered?: boolean;
    /**
     * 
     */
    author_user_id?: string;
    /**
     * 
     */
    source_org_name?: string;
    /**
     * 
     */
    connector_message_id?: string;
    /**
     * 
     */
    send_failed?: boolean;
}

/**
 * Check if a given object implements the HospitalMessage interface.
 */
export function instanceOfHospitalMessage(value: object): value is HospitalMessage {
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('author_full_name' in value) || value['author_full_name'] === undefined) return false;
    if (!('date_sent_iso' in value) || value['date_sent_iso'] === undefined) return false;
    return true;
}

export function HospitalMessageFromJSON(json: any): HospitalMessage {
    return HospitalMessageFromJSONTyped(json, false);
}

export function HospitalMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): HospitalMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'lead_id': json['lead_id'],
        'message': json['message'],
        'author_full_name': json['author_full_name'],
        'sent_from_exacare': json['sent_from_exacare'] == null ? undefined : json['sent_from_exacare'],
        'date_sent_iso': json['date_sent_iso'],
        'is_delivered': json['is_delivered'] == null ? undefined : json['is_delivered'],
        'author_user_id': json['author_user_id'] == null ? undefined : json['author_user_id'],
        'source_org_name': json['source_org_name'] == null ? undefined : json['source_org_name'],
        'connector_message_id': json['connector_message_id'] == null ? undefined : json['connector_message_id'],
        'send_failed': json['send_failed'] == null ? undefined : json['send_failed'],
    };
}

export function HospitalMessageToJSON(json: any): HospitalMessage {
    return HospitalMessageToJSONTyped(json, false);
}

export function HospitalMessageToJSONTyped(value?: HospitalMessage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'message': value['message'],
        'author_full_name': value['author_full_name'],
        'sent_from_exacare': value['sent_from_exacare'],
        'date_sent_iso': value['date_sent_iso'],
        'is_delivered': value['is_delivered'],
        'author_user_id': value['author_user_id'],
        'source_org_name': value['source_org_name'],
        'connector_message_id': value['connector_message_id'],
        'send_failed': value['send_failed'],
    };
}

